
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/SimpleCycles",
      function () {
        return require("private-next-pages/SimpleCycles.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/SimpleCycles"])
      });
    }
  